export default {
  content: {
    id: 'product_jp_product_condition_screen_carousel_grade_b_content',
    defaultMessage:
      'There are minor scratches that are only visible from a distance of 50cm.',
  },
  pill1: {
    id: 'product_jp_product_condition_screen_carousel_grade_b_pill_1',
    defaultMessage: 'Verified parts',
  },
  grade: {
    id: 'product_jp_grade_11',
    defaultMessage: 'B grade (Good)',
  },
}
